import type { MoneyInputValue } from "@oysterhr/feature-components"
import type { AnnualLeavePearlFields } from "./AnnualLeaveSection/getAdvisorKey"
import type { CommissionPlanFormValues } from "./CommissionPlanSection"
import type { AnnualLeaveFormValues } from "./AnnualLeaveSection"
import type { EquitySectionFormValues } from "./EquitySection"
import type { RemoteWorkPolicyFormValues } from "./RemoteWorkCostSection/RemoteWorkPolicySection"
import type { RemoteWorkEquipmentFormValues } from "./RemoteWorkEquipmentSection"
import type { VariableCompensationFormValues } from "~/shared/components/FormSections/CompensationSection/VariableCompensation/types"
import type { SickPayFormValues } from "./sickPaySection/useSickPayValidationSchema"

export type CompensationAndBenefitsPearlFields =
  | "variableCompensation.salaryAmount"
  | "variableCompensation.bonus"
  | "variableCompensation.allowance"
  | "notes"
  | "providedEquipmentPolicy"
  | "sickPayPolicy"
  | AnnualLeavePearlFields

/**
 * Frontend-only form values only used to validate
 * if the user has saved the "subform" fields
 * (reimbursements and remote work costs policies).
 * They won't be sent to the backend.
 */
type BenefitsEditingValidation = {
  reimbursementBudgetEditingValidation: boolean
  remoteWorkEquipmentPolicyEditingValidation: boolean
  remoteWorkExpensePolicyEditingValidation: boolean
}

export type CompensationAndBenefitsValues = {
  salary: MoneyInputValue
  benefitsDescription?: string
  privateNotes?: string
  salaryPeriod?: SalaryPeriodEnumType
} & BenefitsEditingValidation &
  CommissionPlanFormValues &
  AnnualLeaveFormValues &
  EquitySectionFormValues &
  RemoteWorkPolicyFormValues &
  RemoteWorkEquipmentFormValues &
  VariableCompensationFormValues &
  SickPayFormValues

export enum SalaryPeriodEnumType {
  Hourly = "HOURLY",
  Yearly = "YEARLY",
}

export type SalaryFieldsKeys = Extract<
  keyof CompensationAndBenefitsValues,
  "salary" | "salaryPeriod"
>

export type SalaryFormValues = Pick<CompensationAndBenefitsValues, "salary" | "salaryPeriod">
